import { CallListDrawer } from '../drawers/CallListDrawer';
import { ConvertSendoverToSendoutDrawer } from '../drawers/ConvertSendoverToSendoutDrawer';
import { CreateCallDrawer } from '../drawers/CreateCallDrawer';
import { CreateSendoutDrawer } from '../drawers/CreateSendoutDrawer';
import { CreateSendoutInterviewDrawer } from '../drawers/CreateSendoutInterviewDrawer';
import { CreateSendoverDrawer } from '../drawers/CreateSendoverDrawer';
import { DraftsDrawer } from '../drawers/DraftsDrawer';
import { DuplicatesDrawer } from '../drawers/DuplicatesDrawer';
import { SendoutDeclinationReasonsDrawer } from '../drawers/SendoutDeclinationReasonsDrawer';
import { SendoutDetailsDrawer } from '../drawers/SendoutDetailsDrawer';
import { SendoutDetailsEditDrawer } from '../drawers/SendoutDetailsEditDrawer';
import {
  SendoutInterviewDebriefDetailsDrawer,
  SendoutInterviewDebriefEditDrawer
} from '../drawers/SendoutInterviewDebriefDrawer';
import { SendoutInterviewDetailsDrawer } from '../drawers/SendoutInterviewDetailsDrawer';
import { SendoverDeclinationReasonsDrawer } from '../drawers/SendoverDeclinationReasonsDrawer';
import { SendoverDetailsDrawer } from '../drawers/SendoverDetailsDrawer';

import { DRAWER_TYPES } from './DrawerStack.types';

export const DRAWER_REGISTRY_MAP = {
  [DRAWER_TYPES.CallList]: CallListDrawer,
  [DRAWER_TYPES.ConvertSendoverToSendout]: ConvertSendoverToSendoutDrawer,
  [DRAWER_TYPES.CreateCall]: CreateCallDrawer,
  [DRAWER_TYPES.CreateSendoutInterview]: CreateSendoutInterviewDrawer,
  [DRAWER_TYPES.CreateSendout]: CreateSendoutDrawer,
  [DRAWER_TYPES.CreateSendover]: CreateSendoverDrawer,
  [DRAWER_TYPES.Drafts]: DraftsDrawer,
  [DRAWER_TYPES.Duplicates]: DuplicatesDrawer,
  [DRAWER_TYPES.SendoutDeclinationReasons]: SendoutDeclinationReasonsDrawer,
  [DRAWER_TYPES.SendoutDetails]: SendoutDetailsDrawer,
  [DRAWER_TYPES.SendoutDetailsEdit]: SendoutDetailsEditDrawer,
  [DRAWER_TYPES.SendoutInterviewDebriefDetails]: SendoutInterviewDebriefDetailsDrawer,
  [DRAWER_TYPES.SendoutInterviewDebriefEdit]: SendoutInterviewDebriefEditDrawer,
  [DRAWER_TYPES.SendoutInterviewDetails]: SendoutInterviewDetailsDrawer,
  [DRAWER_TYPES.SendoverDeclinationReasons]: SendoverDeclinationReasonsDrawer,
  [DRAWER_TYPES.SendoverDetails]: SendoverDetailsDrawer
};
